import type { ApiRequest } from '@/types/api';
import type { Payment } from '@/types/models';

export type MoveMoneyRequest = ApiRequest<
    'POST',
    'transfers',
    {
        data: Payment;
        meta: {
            user_message: string;
        };
    },
    {
        otp_token: string;
        amount: number;
        currency: 'SAR';
        source_bank_account_id: string;
        destination_bank_account_id?: string;
        beneficiary_id?: string;
        invoice_id?: string;
        submit_at?: string;
    }
>;

type MoveMoneyApi = {
    move: MoveMoneyRequest['url'];
};

export const moveMoneyApi: MoveMoneyApi = {
    move: 'transfers',
};
